import changeIsLoading from '../../actions/changeIsLoading';
import initializeAutomaticRepliesViewState from 'mini-options-store/lib/actions/automaticReplies/initializeAutomaticRepliesViewState';
import loadAutomaticReplies from '../../actions/automaticReplies/loadAutomaticReplies';
import loadMailboxAutomaticRepliesConfiguration from '../../services/loadMailboxAutomaticRepliesConfiguration';
import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';
import updateAutomaticRepliesViewState from 'mini-options-store/lib/actions/automaticReplies/updateAutomaticRepliesViewState';
import { orchestrator } from 'satcheljs';
import { trace } from 'owa-trace';

const loadAutomaticRepliesOptionOrchestrator = orchestrator(loadAutomaticReplies, async () => {
    initializeAutomaticRepliesViewState();
    // start loading
    changeIsLoading(true);

    try {
        // get the automatic reply configuration from the server
        const mailboxAutoReplyConfiguration: MailboxAutoReplyConfigurationOptions = await loadMailboxAutomaticRepliesConfiguration();
        // update the view state
        updateAutomaticRepliesViewState(mailboxAutoReplyConfiguration);
    } catch (e) {
        trace.warn(e.message || 'initLoadMailboxAutomaticRepliesConfiguration failed');
    }

    // remove loading
    changeIsLoading(false);
});

export default loadAutomaticRepliesOptionOrchestrator;
